// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2mA9I","subheader":"ReorderModal_subheader__FFVhg","listWrap":"ReorderModal_listWrap__1qJvh"};